export function WhyKavishSection({ lookUpCMSData }: any) {
  if (!lookUpCMSData?.["Home - Section 4 : Why Guests Choose Kavish"]) return;
  return (
    <>
      {lookUpCMSData?.["Home - Section 4 : Why Guests Choose Kavish"] && (
        <div
          dangerouslySetInnerHTML={{
            __html:
              lookUpCMSData?.[
                "Home - Section 4 : Why Guests Choose Kavish"
              ]?.Template?.trim(),
          }}
        />
      )}

      {/* <section className="py-10 md:py-20 bg-white relative overflow-hidden">
        <div className="absolute top-1/2 left-0 w-96 h-96 bg-[#F9F7F4] rounded-full blur-3xl opacity-50 -translate-y-1/2 -translate-x-1/2" />
        <div className="absolute top-1/2 right-0 w-96 h-96 bg-[#F9F7F4] rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/2" />

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-20">
              <div className="inline-flex items-center gap-2 bg-[#F9F7F4] px-6 py-3 rounded-full mb-6">
                <Award className="h-4 w-4 text-[#B42025]" />
                <span className="text-[#B42025] tracking-[0.3em] text-sm uppercase">
                  The Kavish Difference
                </span>
              </div>
              <h2 className="text-4xl md:text-6xl mb-6 text-[#1A1A1A]">
                Why Guests Choose Kavish
              </h2>
              <div className="w-24 h-1 bg-[#C9A962] mx-auto" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="group relative bg-[#F9F7F4] p-8 rounded-2xl hover:bg-white hover:shadow-xl transition-all duration-300 border border-transparent hover:border-[#B42025]/20"
                >
                  <div className="absolute -top-4 -right-4 w-12 h-12 bg-[#B42025] rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <span className="text-white text-sm">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                  </div>

                  <div className="flex items-start gap-5">
                    <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#B42025] flex items-center justify-center group-hover:bg-[#8F1A1E] transition-colors duration-300">
                      <Check className="h-5 w-5 text-white" />
                    </div>
                    <div>
                      <h3 className="text-xl text-[#1A1A1A] mb-2 leading-tight">
                        {feature.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
}
